import React from "react";
import { Award, ShieldCheck } from "lucide-react";
import { certifications } from "../../mock";

const Quality = () => {
  return (
    <section id="quality" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-6 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <div className="text-[12px] uppercase tracking-[0.22em] font-semibold text-teal-700">Quality &amp; Compliance</div>
          <h2 className="mt-3 font-display font-extrabold text-slate-900 text-[34px] lg:text-[46px] leading-[1.08]">
            Every batch <span className="text-gradient-brand">tested, documented, traceable</span>
          </h2>
          <p className="mt-5 text-slate-600 text-[16px] leading-relaxed">
            Our in-house QC lab tests every production batch for purity, density, chloride/sulphate content and heavy-metal limits. A signed Certificate of Analysis and MSDS travels with every consignment.
          </p>
          <div className="mt-7 flex items-start gap-4 p-5 rounded-2xl bg-teal-50 border border-teal-100">
            <ShieldCheck className="h-7 w-7 text-teal-700 mt-0.5 shrink-0" />
            <div>
              <div className="font-display font-bold text-slate-900">Pharma-grade documentation</div>
              <div className="text-[14px] text-slate-600 mt-1">CoA, MSDS, TDS, batch records and e-way bills — emailed before the tanker leaves our gate.</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="grid grid-cols-2 gap-4">
            {certifications.map((c) => (
              <div key={c.code} className="card-lift bg-white rounded-2xl border border-slate-200 p-5">
                <div className="h-10 w-10 rounded-lg brand-band flex items-center justify-center">
                  <Award className="h-5 w-5 text-white" />
                </div>
                <div className="mt-4 font-display font-extrabold text-slate-900 text-[15.5px]">{c.code}</div>
                <div className="text-[12.5px] text-slate-500 mt-1">{c.body}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Quality;
